import { Link } from 'react-router'

import logo from 'Images/logo'

const AppLogo = () => (
  <Link aria-label="ExpanDrive Teams Home" className="tw:flex tw:shrink-0 tw:items-center" to="/configurations">
    <img alt="ExpanDrive" className="tw:h-auto tw:w-[168px] tw:phone:w-[144px]" src={logo} />
  </Link>
)

export default AppLogo
